import React from 'react';
import { View } from 'react-native';

import moment from 'moment';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import { getDateBarNumber } from '../helpers';
import TimelineAddOnCard from '../TimelineAddOnsList/TimelineAddOnCard';

import styles from './CurrentPlan.Styles';

function CurrentPlan({
  positionTop,
  images,
  slot,
  currentPlan,
  currentPlanIconName,
  renewableAddonIconName,
  dates,
  theme,
}) {
  const { currencyTransformer, dateFormats, dateTransformer } =
    DateCurrencyFromatter.dateCurrencyFromatter;

  const barShift = 21;

  const currentPlanHeight = 0.9 * (slot + 12);
  const expiredOrRenewableHeight = 0.6 * (slot + 12);

  const startDate = currentPlan.startDate;
  const endDate = currentPlan.endDate;

  const currentPlanLastMonth = dateTransformer(
    moment(startDate).subtract(1, 'M'),
    dateFormats.calendarFormat,
  );
  const currentPlanNextMonth = dateTransformer(
    moment(endDate).add(1, 'M'),
    dateFormats.calendarFormat,
  );

  const currentPlanHistoryBarNumber = getDateBarNumber(dates, {
    date: currentPlanLastMonth,
  });

  const currentPlanStartDateBarNumber = getDateBarNumber(dates, {
    date: startDate,
  });
  const currentPlanEndDateBarNumber = getDateBarNumber(dates, { date: endDate });
  const currentPlanRenewalEndDateBarNumber = getDateBarNumber(dates, {
    date: currentPlanNextMonth,
  });

  const _currentPlanHistoryWidth = currentPlanStartDateBarNumber - currentPlanHistoryBarNumber;
  const _currentPlanWidth = currentPlanEndDateBarNumber - currentPlanStartDateBarNumber;
  const _currentPlanRenewalWidth = currentPlanRenewalEndDateBarNumber - currentPlanEndDateBarNumber;

  const lastPlanWidth = _currentPlanHistoryWidth * slot;
  const currentPlanWidth = _currentPlanWidth * slot;
  const nextPlanWidth = _currentPlanRenewalWidth * slot;

  const lastPlanPositionLeft = currentPlanHistoryBarNumber * slot + barShift;
  const currentPlanPositionLeft = currentPlanStartDateBarNumber * slot + barShift;
  const nextPlanPositionLeft = currentPlanEndDateBarNumber * slot + barShift;

  const addOn = {
    id: 'my_plan_id_0',
    name: currentPlan.name,
    icon: currentPlanIconName,
    price: currentPlan.value,
  };

  return (
    <>
      <TimelineAddOnCard
        images={images}
        addOn={addOn}
        height={expiredOrRenewableHeight}
        fullWidth={true}
        width={lastPlanWidth}
        left={lastPlanPositionLeft}
        top={positionTop + 25}
        type="expired"
      />

      <View
        style={styles.container(
          theme,
          currentPlanWidth,
          currentPlanHeight,
          positionTop,
          currentPlanPositionLeft,
        )}
      >
        <View style={styles.currentPlanTextWrapper}>
          <VFText style={styles.currentPlanText(theme)} i18nKey={currentPlan.name} />
        </View>
        <View style={styles.currentPlanBody(theme)}>
          <Icon name={images.icMobile} type="image" style={styles.icon} size={24} />
          <View style={styles.textWrapper}>
            <VFText style={styles.name} i18nKey={currentPlan.name} />
            <VFText
              style={styles.price(theme)}
              i18nKey={`${currencyTransformer(currentPlan.value, 0)}${currentPlan.currency}`}
            />
          </View>
        </View>
      </View>

      <TimelineAddOnCard
        images={images}
        addOn={{
          ...addOn,
          icon: renewableAddonIconName,
        }}
        height={expiredOrRenewableHeight}
        price={currencyTransformer(currentPlan.value, 0)}
        fullWidth={true}
        width={nextPlanWidth}
        left={nextPlanPositionLeft}
        top={positionTop + 25}
        type="renewable"
      />
    </>
  );
}
CurrentPlan.defaultProps = {
  theme: LightThemeColors,
  isMonthView: true,
};
CurrentPlan.propTypes = {
  positionTop: PropTypes.number,
  isMonthView: PropTypes.bool,
  currentPlanIconName: PropTypes.string,
  renewableAddonIconName: PropTypes.string,
  images: PropTypes.object,
  slot: PropTypes.number,
  data: PropTypes.array,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  currentPlan: PropTypes.shape({
    name: PropTypes.string,
    currency: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    value: PropTypes.number,
  }),
  dates: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
export default withTheme(CurrentPlan);
